import React from 'react';
import PropTypes from 'prop-types';
import FormRadio from '../FormRadio/FormRadio';
import './FormRadioGroup.scss';

const FormRadioGroup = (props) => {
  const radioName = props.name;
  const selectedId = props.selectedId;
  const radioInput = props.input;
  const radioGroupMeta = props.meta;
  const radioDispatch = props.dispatch;
  return (
    <div>
      <ul>
        {props.radioButtons.map(radioButton =>
          <li className="form-radio-group-item" key={radioButton.id}>
            <FormRadio
              id={radioButton.id}
              name={radioName}
              label={radioButton.label}
              autotestClass={radioButton.autotestClass}
              input={radioInput}
              checked={selectedId === radioButton.id}
              disabled={radioButton.disabled}
              dispatch={radioDispatch}
            />
          </li>
        )}
      </ul>
      {
        radioGroupMeta && radioGroupMeta.touched && radioGroupMeta.error &&
        <span className="form-validation-message">{radioGroupMeta.error}</span>
      }
    </div>
  );
};

FormRadioGroup.propTypes = {
  name: PropTypes.string,
  radioButtons: PropTypes.arrayOf(PropTypes.object),
  selectedId: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  dispatch: PropTypes.func
};

export default FormRadioGroup;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormRadioGroup/FormRadioGroup.js
 **/